import { useState, useEffect } from 'react';
import MuiModal from '@mui/material/Modal';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import { Typography } from '@components/Typography';
import { useTranslation } from '@hooks';

const Modal = styled(MuiModal)({
    zIndex: 99999,
});

const Content = styled('div')({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    outline: 'none',
});

const Bar = styled(LinearProgress)({
    width: 280,
    height: 6,
    borderRadius: 3,
    marginTop: 16,
    backgroundColor: 'rgba(255, 255, 255, 0.25)',
    '& .MuiLinearProgress-bar': {
        backgroundColor: '#fff',
    },
});

const ROTATION_INTERVAL = 10000;

const ImportLoadingOverlay = ({ open, messages, current, total }) => {
    const { t } = useTranslation();
    const [textIndex, setTextIndex] = useState(0);

    const showProgress = typeof total === 'number' && total > 0;

    const displayMessages = messages || [
        t('importLoading.connectingGoogle'),
        t('importLoading.fetchingDetails'),
        t('importLoading.settingUp'),
        t('importLoading.almostDone'),
    ];

    useEffect(() => {
        if (!open || showProgress || displayMessages.length === 0) {
            setTextIndex(0);
            return;
        }

        const interval = setInterval(() => {
            setTextIndex(prev => (prev + 1) % displayMessages.length);
        }, ROTATION_INTERVAL);

        return () => clearInterval(interval);
    }, [open, showProgress, displayMessages.length]);

    return (
        <Modal open={open}>
            <Content>
                {showProgress ? (
                    <>
                        <Typography variant="body1" sx={{ color: '#fff', textAlign: 'center' }}>
                            {t('importLoading.progress', { current, total })}
                        </Typography>
                        <Bar variant="determinate" value={Math.round((current / total) * 100)} />
                    </>
                ) : (
                    <>
                        <CircularProgress sx={{ color: '#fff', marginBottom: '24px' }} size={48} />
                        <Typography variant="body1" sx={{ color: '#fff', textAlign: 'center' }}>
                            {displayMessages[textIndex]}
                        </Typography>
                    </>
                )}
            </Content>
        </Modal>
    );
};

export default ImportLoadingOverlay;
